<template>
  <div class="container-page">
    <div class="card-mpk" v-if="item.id">
      <p class="card-mpk__title title-inner">Карточка поручения по МПК</p>
      <div class="card-mpk__body">
        <div class="card-mpk__card">
          <div class="card-mpk__card-body">
            <div class="card-mpk__card-row">
              <div class="card-mpk__card-col1">
                <p class="title-column">Страна</p>
                <p>
                  {{ item.countryName }}
                </p>
                <p class="title-column mt-16">Мероприятия</p>
                <p>
                  {{ item.eventName }}
                </p>
              </div>
              <div class="card-mpk__card-col2">
                <p class="title-column">МПК</p>
                <p>
                  {{ item.mpkName }}
                </p>
              </div>
            </div>

            <div class="card-mpk__card-row">
              <div class="card-mpk__card-col1">
                <p class="title-column">Исполнитель</p>
                <p v-if="groupedExecutors.executors.length">
                  {{ groupedExecutors.executors }}
                </p>
              </div>
              <div class="card-mpk__card-col2" v-if="groupedExecutors.coexecutors.length">
                <p class="title-column">Соисполнители</p>
                <p>{{ groupedExecutors.coexecutors }}</p>
              </div>
            </div>

            <div class="card-mpk__card-row">
              <div class="card-mpk__card-col1">
                <p class="title-column">Номер и дата поручения Правительства РФ</p>
                <p>
                  {{ item?.razdelProtocal || '' }}
                </p>
              </div>
              <div class="card-mpk__card-col2">
                <p class="title-column">Периодичность отчета</p>
                <p>
                  {{ reportFrequencyText }}
                </p>
              </div>
            </div>
            <div class="card-mpk__card-row">
              <div class="card-mpk__card-col1">
                <p class="title-column">Номер пункта поручения</p>
                <p>
                  {{ item.noPoint }}
                </p>
              </div>
            </div>
            <div class="card-mpk__card-row">
              <div class="card-mpk__card-col1">
                <p class="title-column">Содержание поручения</p>
                <p>
                  {{ item.brief }}
                </p>
              </div>
            </div>

            <div class="card-mpk__card-row">
              <div class="card-mpk__card-col1">
                <p class="title-column">Срок исполнения</p>
                <p>
                  {{ !item.isPermanent ? $momentFormat(item.srok, 'D MMMM YYYY') : '' }}
                  <span v-if="item.isPermanent">Выполняется на постоянной основе</span>
                </p>
              </div>
              <div class="card-mpk__card-col2">
                <p class="title-column">Срок отчета в Минэкономразвития России</p>
                <p>
                  {{ $momentFormat(item.deadline, 'D MMMM YYYY') }}
                </p>
              </div>
            </div>

            <div class="card-mpk__card-row" v-if="!item.isStart">
              <div class="card-mpk__card-col2 status">
                <p class="title-column">Статус</p>
                <div class="d-flex status-container text-red">
                  <IconComponent name="cir-close" />
                  <span class="text-red">Проект поручения. Направьте на исполнение</span>
                </div>
              </div>
            </div>

            <template v-if="item.isStart">
              <template v-for="assignmentExecutor in sortedExecutors" :key="assignmentExecutor.id">
                <!-- row  report-->
                <div class="card-mpk__card-row report">
                  <!-- cols -->
                  <div class="card-mpk__card-col1 report-container">
                    <p class="title-column">
                      Отчет
                      <!-- Имя организации от которой оставлен отчет -->
                      <span class="report-name">{{
                        assignmentExecutor.organizationName || assignmentExecutor.coexecutor
                      }}</span>
                    </p>
                    <div class="report-column">
                      <!-- текст отчета здесь -->
                      <template v-for="el in assignmentExecutor.mpkAssignmentExecutorReports" :key="el.id">
                        <p class="report-text">
                          {{ el.report }}
                          <FileMultiUpload
                            :entity="el"
                            propName="files"
                            readonly
                            v-if="el.files && el.files.length > 0"
                          />
                        </p>
                      </template>

                      <div v-if="checkInApprovalRange(assignmentExecutor)">
                        <CheckboxInput
                          v-model="assignmentExecutor.isExecute"
                          label="Поручение выполнено"
                          :disabled="!assignmentExecutor.canApprove || checkExecutorApprovalStatus(assignmentExecutor)"
                        />
                      </div>
                      <div class="btn-container d-flex flex-wrap w100">
                        <ButtonComponent
                          v-if="
                            assignmentExecutor.canTakeInWork &&
                            assignmentExecutor.statusId === MPK_ASSIGNMENT_STATUS.NEW
                          "
                          mod="gradient-bg"
                          @click="onTakeInWork(assignmentExecutor)"
                        >
                          Взять в работу
                        </ButtonComponent>
                        <template v-if="!assignmentExecutor.postponed">
                          <ButtonComponent
                            v-if="assignmentExecutor.canApprove && checkIsNotNewTask(assignmentExecutor)"
                            mod="gradient-bg"
                            @click="confirmReport(assignmentExecutor)"
                            :disabled="!assignmentExecutor.report || pending"
                          >
                            {{ !checkIsNotInWorkStatus(assignmentExecutor) ? 'На согласование' : 'Согласовать' }}
                          </ButtonComponent>
                          <ButtonComponent
                            v-if="assignmentExecutor.canEdit"
                            mod="border"
                            @click="createReport(assignmentExecutor)"
                          >
                            {{ assignmentExecutor.report ? 'Отредактировать отчет' : 'Внести отчет' }}
                          </ButtonComponent>
                          <ButtonComponent
                            v-if="assignmentExecutor.canApprove && checkIsNotInWorkStatus(assignmentExecutor)"
                            mod="border"
                            @click="cancelReport(assignmentExecutor)"
                          >
                            Отклонить отчет
                          </ButtonComponent>
                        </template>
                        <ButtonComponent
                          v-if="
                            assignmentExecutor.mpkAssignmentExecutorRefuses &&
                            assignmentExecutor.mpkAssignmentExecutorRefuses.length > 0
                          "
                          mod="border"
                          @click="showRefuseReason(assignmentExecutor)"
                        >
                          Причины отказа
                        </ButtonComponent>
                        <ButtonComponent
                          v-if="checkComments(assignmentExecutor)"
                          mod="border"
                          @click="showComments(assignmentExecutor.mpkAssignmentExecutorConfirms)"
                        >
                          Комментарий
                        </ButtonComponent>
                      </div>
                    </div>
                  </div>
                  <div class="card-mpk__card-col2 status">
                    <p class="title-column">Статус</p>
                    <div class="d-flex status-container" :class="getStatusVisual(assignmentExecutor).class">
                      <IconComponent :name="getStatusVisual(assignmentExecutor).icon" />
                      <span :class="getStatusVisual(assignmentExecutor).class">{{
                        assignmentExecutor.statusName
                      }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <div class="card-mpk__card-row" v-if="showAssignmentControls">
                <div class="card-mpk__card-col1">
                  <div class="btn-container d-flex flex-wrap w100">
                    <ButtonComponent
                      v-if="canPostponeAssignment && !isAssignmentPostponed"
                      mod="border"
                      @click="setPostponedAll()"
                      :disabled="pendingPostponed || pending"
                    >
                      {{ pendingPostponed ? 'Приостановка...' : 'Приостановить' }}
                    </ButtonComponent>
                    <ButtonComponent v-if="canPostponeAssignment" mod="border" @click="openCancelStatus()">
                      Не выполнено
                    </ButtonComponent>
                    <ButtonComponent
                      v-if="canReturnFromDoneAssignment"
                      mod="gradient-bg"
                      @click="setPostponedAll(false)"
                      :disabled="pendingPostponed"
                    >
                      {{ pendingPostponed ? 'Отправка...' : 'Вернуть в работу' }}
                    </ButtonComponent>
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <div class="card-mpk__card-row" v-if="showActionButtons">
                <div class="card-mpk__card-col1 report-container">
                  <div class="report-column">
                    <div class="btn-container d-flex flex-wrap w100">
                      <ButtonComponent mod="gradient-bg" v-if="canStart" @click="onStart()">
                        На исполнение
                      </ButtonComponent>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <AssignmentChat :orgList="orgs" :assignmentId="id" />
      </div>

      <div class="mt-3">
        <ButtonComponent mod="border" @click="close">Закрыть</ButtonComponent>
      </div>

      <!-- Модальное окно перевод в 1 статус (Новое). Комментарий необязательный -->
      <ModalComponent title="На исполнение" @close="dialogOnStart = false" v-model="dialogOnStart">
        <div class="form__body cancel">
          <div class="form__body-inputBlock mb-16">
            <p>Комментарий</p>
            <textarea placeholder="Добавьте комментарий при необходимости" v-model="comment"></textarea>
          </div>
          <div>
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="onStartSend" :disabled="pending">
              {{ pending ? 'Отправка...' : 'Подтвердить' }}
            </ButtonComponent>
            <ButtonComponent @click="dialogOnStart = false" mod="border">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <!-- Модалка: Взять в работу -->
      <ModalComponent title="Взять в работу" @close="dialogTakeInWork = false" v-model="dialogTakeInWork">
        <div class="form__body cancel">
          <p>Вы уверены, что хотите взять поручение в работу?</p>
          <div class="mt-3">
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="onTakeInWorkSend" :disabled="pending">
              {{ pending ? 'Отправка...' : 'Подтвердить' }}
            </ButtonComponent>
            <ButtonComponent @click="dialogTakeInWork = false" mod="border">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <!-- Модалка для согласования -->
      <ModalComponent :title="approveModalTitle" @close="dialogConfirm = false" v-model="dialogConfirm">
        <div class="form__body cancel">
          <div class="form__body-inputBlock pb-4 mb-4" v-if="showDeadlineInput(assignmentExecutor)">
            <p>Срок отчета в Минэкономразвития России</p>
            <DateComponent v-model="itemDeadline" :clearable="true" required />
          </div>
          <div class="form__body-inputBlock pb-4 mb-4">
            <p>Комментарий</p>
            <textarea placeholder="Добавьте комментарий при необходимости" v-model="reason"></textarea>
          </div>
          <div>
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="confirmReportSend" :disabled="pending">
              {{ pending ? 'Отправка...' : 'Подтвердить' }}
            </ButtonComponent>
            <ButtonComponent @click="dialogConfirm = false" mod="border">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent title="Отклонить" @close="dialogCancel = false" v-model="dialogCancel">
        <div class="form__body cancel">
          <div class="form__body-inputBlock required pb-4 mb-4">
            <label class="form-label">Причина</label>
            <textarea placeholder="Напишите причину отклонения" v-model="reason"></textarea>
            <div class="invalid-msg" v-if="v$.reason.$error">Поле обязательно для заполнения</div>
          </div>
          <div>
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="cancelReportSend" :disabled="pending">
              {{ pending ? 'Отправка...' : 'Подтвердить' }}
            </ButtonComponent>
            <ButtonComponent @click="dialogCancel = false" mod="border">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent title="Поручение не выполнено" @close="dialogCancelStatus = false" v-model="dialogCancelStatus">
        <div class="form__body cancel">
          <div class="form__body-inputBlock required pb-4 mb-4">
            <ComponentInput
              label="Статус"
              type="select2"
              :select2Options="cancelStatusOptions"
              v-model="selectedCancelStatusId"
              required
            />
            <div class="invalid-msg" v-if="v$.selectedCancelStatusId.$error">Поле обязательно для заполнения</div>
          </div>
          <div class="form__body-inputBlock required pb-4 mb-4">
            <label class="form-label">Причина</label>
            <textarea placeholder="Напишите причину невыполнения" v-model="reason"></textarea>
            <div class="invalid-msg" v-if="v$.reason.$error">Поле обязательно для заполнения</div>
          </div>
          <div>
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="cancelStatusSend" :disabled="pending">
              {{ pending ? 'Отправка...' : 'Подтвердить' }}
            </ButtonComponent>
            <ButtonComponent @click="dialogCancelStatus = false" mod="border">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent title="Внести отчет" @close="dialogMakeReport = false" v-model="dialogMakeReport">
        <div class="form__body cancel">
          <div class="form__body-inputBlock required mb-16">
            <label class="form-label">Отчет</label>
            <textarea placeholder="Вставьте или напишите здесь текст отчета" v-model="modal.report" required></textarea>
            <div class="invalid-msg" v-if="v$.modal.report.$error">Поле обязательно для заполнения</div>
          </div>
          <div class="form__body-inputBlock mb-16">
            <p>Приложить документы</p>
            <FileMultiUpload
              :entity="modal"
              @deleteFile="removeFile"
              propName="files"
              @uploaded="fileUploaded"
              :readonly="isReadonly"
              isCaptionVisible="true"
            />
          </div>
          <div class="form__body-inputBlock mb-16">
            <div class="card-mpk__date-form-wrapper">
              <p>Дата выполнения поручения</p>
              <DateComponent modClass="redesigned popover-top" v-model="modal.completionDate" clearable dateIcon />
            </div>
          </div>
          <div>
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="createReportSend" :disabled="pending">
              {{ pending ? 'Сохранение...' : 'Сохранить' }}
            </ButtonComponent>
            <ButtonComponent @click="dialogMakeReport = false" mod="border">Отмена</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent title="Причины отказа" @close="dialogRefuse = false" v-model="dialogRefuse">
        <div class="form__body cancel">
          <div class="form__body-inputBlock mb-16 pb-4">
            <template v-for="reason in refuseReasons" :key="reason.id">
              <p>{{ reason.createdBy.fullName }} ({{ $momentFormat(reason.created, 'D MMMM YYYY') }})</p>
              <div>{{ reason.reason }}</div>
            </template>
          </div>
          <div>
            <ButtonComponent @click="dialogRefuse = false" mod="border">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent title="Комментарии" @close="dialogComment = false" v-model="dialogComment">
        <div class="form__body cancel">
          <div class="form__body-inputBlock pb-0 mb-4">
            <template v-for="com in commentList" :key="com.id">
              <p>
                {{ com.createdBy.fullName }}<span v-if="com.organization">, {{ com.organization }}</span> ({{
                  $momentFormat(com.created, 'D MMMM YYYY')
                }})
              </p>
              <p v-if="com.statusName">Статус: {{ com.statusName }}</p>
              <div class="mb-4">{{ com.comment }}</div>
            </template>
          </div>
          <div>
            <ButtonComponent @click="dialogComment = false" mod="border">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import FileMultiUpload from '@/common/components/FileMultiUpload.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import API from '../api/assignment';
  import AssignmentChat from '../components/AssignmentChat.vue';
  import { MPK_ASSIGNMENT_STATUS, MPK_ROLE_ID } from '../utils/constants';

  export default {
    name: 'AssignmentCard',
    components: {
      CheckboxInput,
      ButtonComponent,
      ComponentInput,
      IconComponent,
      ModalComponent,
      AssignmentChat,
      FileMultiUpload,
      DateComponent,
    },
    mixins: [security],
    data() {
      return {
        MPK_ASSIGNMENT_STATUS,
        id: Number(this.$route.params.id),
        isReadonly: this.$route.params.action === 'view',
        item: {},
        assignmentExecutorId: 0,
        assignmentExecutor: {},
        modal: {
          report: '',
          files: [],
        },
        reason: '',
        comment: '',
        approveModalTitle: '',
        refuseReasons: [],
        commentList: [],

        dialogMakeReport: false,
        dialogCancel: false,
        dialogCancelStatus: false,
        dialogRefuse: false,
        dialogConfirm: false,
        dialogComment: false,
        dialogOnStart: false,
        dialogTakeInWork: false,

        canStart: false,
        selectedCancelStatusId: null,
        cancelStatusOptions: [
          { id: MPK_ASSIGNMENT_STATUS.NOT_COMPLETED, text: 'Не выполнено' },
          { id: MPK_ASSIGNMENT_STATUS.NOT_COMPLETED_FOREIGN, text: 'Не выполнено по вине иностранной стороны' },
          { id: MPK_ASSIGNMENT_STATUS.NOT_DONE_NOT_ACTUAL, text: 'Не выполнено в связи с потерей актуальности' },
        ],
        itemDeadline: null,
        pending: false,
        pendingPostponed: false,
      };
    },
    computed: {
      reportFrequencyText() {
        const isQuarterlyReport = !!this.item?.isQuarterlyReport;
        const isSemiAnnualReport = !!this.item?.isSemiAnnualReport;
        if (isQuarterlyReport) return 'Ежеквартальный отчет';
        if (isSemiAnnualReport) return 'Полугодовой отчет';

        return 'Единоразовый отчет';
      },
      orgs() {
        return this.item && this.item.assignmentExecutors
          ? this.item.assignmentExecutors.map((x) => ({ text: x.organizationName, id: x.organizationId }))
          : [];
      },
      sortedExecutors() {
        if (!this.item || !this.item.assignmentExecutors) return [];
        // Сортировка отчетов. Исполнитель первый, а дальше соисполнители
        return [...this.item.assignmentExecutors].sort((a, b) => {
          if (a.isCoexecutor && !b.isCoexecutor) return 1;
          if (!a.isCoexecutor && b.isCoexecutor) return -1;
          return 0;
        });
      },
      groupedExecutors() {
        let result = { executors: '', coexecutors: '' };

        if (!this.item?.assignmentExecutors) return result;

        this.item.assignmentExecutors.forEach((assignmentExecutor) => {
          const targetKey = assignmentExecutor.isCoexecutor ? 'coexecutors' : 'executors';
          const currentValue = result[targetKey];
          const rawName = assignmentExecutor.organizationName || assignmentExecutor.coexecutor;
          if (!rawName) return;

          result[targetKey] += currentValue ? ', ' + rawName : rawName;
        });

        return result;
      },
      isAssignmentPostponed() {
        return this.item.assignmentExecutors.some((e) => e.postponed);
      },
      canPostponeAssignment() {
        return this.item.assignmentExecutors.some((e) => e.canPostpone);
      },
      canReturnFromDoneAssignment() {
        return this.item.assignmentExecutors.some((e) => e.canReturnFromDone);
      },
      showActionButtons() {
        return this.canStart;
      },
      showAssignmentControls() {
        return this.canReturnFromDoneAssignment || this.canPostponeAssignment;
      },
    },
    created() {
      this.checkPermissionAndRedirect(Constants.Permissions.MpkAssignmentAccess);
      this.loadCard();
    },
    watch: {
      dialogOnStart(val) {
        if (!val) this.comment = '';
      },
      dialogConfirm(val) {
        if (!val) {
          this.reason = '';
          this.itemDeadline = this.item?.deadline ?? null;
        }
      },
      dialogCancel(val) {
        if (!val) {
          this.reason = '';
          this.v$.$reset();
        }
      },
      dialogCancelStatus(val) {
        if (!val) {
          this.reason = '';
          this.selectedCancelStatusId = null;
          this.v$.$reset();
        }
      },
    },
    methods: {
      loadCard() {
        if (this.id > 0) {
          API.find(this.id).then((response) => {
            this.item = response.data;

            this.item.assignmentExecutors.forEach((executor) => {
              if (executor.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_HEAD_FOIV && !executor.isCoexecutor)
                executor.isExecute = true;
            });

            let roleIds = [];
            let profile = this.$store.state.auth?.oidc?.profile;
            if (profile == null) profile = JSON.parse(localStorage.getItem('userProfileData'));

            if (profile?.roleIds && profile?.roleIds.length > 0) roleIds = Array.from(profile.roleIds);

            this.canStart = roleIds.includes(MPK_ROLE_ID.SECRETARY_MPK);
            this.itemDeadline = this.item.deadline;
          });
        } else {
          this.close();
        }
      },
      setPostponedAll(isPostponed = true) {
        this.pendingPostponed = true;
        const ids = (this.item.assignmentExecutors ?? []).map((e) => e.id);
        API.setPostponed(ids, isPostponed)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.pendingPostponed = false;
          });
      },
      createReport(assignmentExecutor) {
        this.assignmentExecutorId = assignmentExecutor.id;
        this.v$.$reset();

        const isNewReportStatus =
          assignmentExecutor.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_SECRETARY_EXECUTOR ||
          assignmentExecutor.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_HEAD_EXECUTOR ||
          !assignmentExecutor.report;

        if (isNewReportStatus) {
          this.modal = { report: '', files: [], completionDate: null };
        } else {
          const reports = assignmentExecutor.mpkAssignmentExecutorReports?.filter((x) => !x.isApprove);
          const reportEl = reports?.length ? reports[reports.length - 1] : undefined;
          this.modal = Object.assign(
            {},
            {
              report: reportEl?.report,
              files: [],
              completionDate: reportEl?.completionDate,
            },
          );
          if (reportEl?.files) {
            reportEl?.files.forEach((f) => {
              this.modal.files.push(Object.assign({}, f));
            });
          }
        }

        this.dialogMakeReport = true;
      },
      createReportSend() {
        this.v$.$touch();
        if (this.v$.modal.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }
        this.pending = true;

        const itemToSave = {
          id: this.assignmentExecutorId,
          assignmentExecutorId: this.assignmentExecutorId,
          report: this.modal.report,
          completionDate: this.modal.completionDate,
          documentsIds: this.modal.files.map((x) => x.id),
        };

        API.updateReport(itemToSave)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.dialogMakeReport = false;
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.pending = false;
          });
      },
      openCancelStatus() {
        this.selectedCancelStatusId = MPK_ASSIGNMENT_STATUS.NOT_COMPLETED;
        this.reason = '';
        this.dialogCancelStatus = true;
      },
      cancelStatusSend() {
        this.v$.$touch();
        if (this.v$.reason.$invalid || this.v$.selectedCancelStatusId.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        this.pending = true;

        const ids = (this.item.assignmentExecutors ?? []).map((e) => e.id);
        const itemToSave = {
          reason: this.reason,
          statusId: this.selectedCancelStatusId,
        };

        API.cancelStatus(ids, itemToSave)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.dialogCancelStatus = false;
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.pending = false;
          });
      },
      cancelReport(assignmentExecutor) {
        this.assignmentExecutorId = assignmentExecutor.id;
        this.dialogCancel = true;
      },
      cancelReportSend() {
        this.v$.$touch();
        if (this.v$.reason.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        this.pending = true;

        const itemToSave = {
          assignmentExecutorId: this.assignmentExecutorId,
          reason: this.reason,
        };

        API.refuseReport(itemToSave)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.dialogCancel = false;
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.pending = false;
          });
      },
      confirmReport(assignmentExecutor) {
        this.dialogConfirm = false;

        this.updateModal(assignmentExecutor);

        this.$nextTick(() => {
          this.itemDeadline = this.item.deadline;
          this.assignmentExecutor = assignmentExecutor;
          this.approveModalTitle =
            assignmentExecutor.statusId === MPK_ASSIGNMENT_STATUS.IN_WORK ? 'На согласование' : 'Согласовать';
          this.dialogConfirm = true;
        });
      },
      updateModal(assignmentExecutor) {
        const reportEl = assignmentExecutor.mpkAssignmentExecutorReports?.find((x) => !x.isApprove);
        this.assignmentExecutorId = assignmentExecutor.id;
        this.modal = Object.assign(
          {},
          {
            report: reportEl?.report,
            files: [],
          },
        );
        if (reportEl?.files) {
          reportEl?.files.forEach((f) => {
            this.modal.files.push(Object.assign({}, f));
          });
        }
      },
      confirmReportSend() {
        this.pending = true;
        const itemToSave = { ...this.assignmentExecutor, deadline: this.itemDeadline };
        itemToSave.reason = this.reason ?? '';

        API.approveReport(itemToSave)
          .then(() => {
            this.dialogConfirm = false;
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.pending = false;
          });
      },
      onStart() {
        this.dialogOnStart = true;
      },
      onStartSend() {
        this.pending = true;
        const itemToSave = {
          assignmentId: this.item.id,
          comment: this.comment,
        };

        API.startAssignment(itemToSave)
          .then(() => {
            this.dialogOnStart = false;
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.pending = false;
          });
      },
      checkExecutorApprovalStatus(assignmentExecutor) {
        return (
          assignmentExecutor.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_SECRETARY_EXECUTOR ||
          assignmentExecutor.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_HEAD_EXECUTOR
        );
      },
      getStatusVisual(assignmentExecutor) {
        const statusId = assignmentExecutor.statusId;
        const isOverdue = !!assignmentExecutor.overDue && !assignmentExecutor.isPermanent;

        if (assignmentExecutor.postponed) return { icon: 'cir-close', class: 'text-red' };

        if (statusId === MPK_ASSIGNMENT_STATUS.COMPLETED) return { icon: 'cir-done', class: 'text-green' };

        const notCompletedFamily = [
          MPK_ASSIGNMENT_STATUS.NOT_COMPLETED,
          MPK_ASSIGNMENT_STATUS.NOT_COMPLETED_FOREIGN,
          MPK_ASSIGNMENT_STATUS.NOT_DONE_NOT_ACTUAL,
        ];

        if (notCompletedFamily.includes(statusId))
          return { icon: 'cir-close', class: isOverdue ? 'text-red' : 'text-yellow' };

        if (isOverdue) return { icon: 'cir-late', class: 'text-red' };

        return { icon: 'cir-inWork', class: 'text-yellow' };
      },
      onTakeInWork(assignmentExecutor) {
        this.assignmentExecutor = assignmentExecutor;
        this.dialogTakeInWork = true;
      },
      onTakeInWorkSend() {
        this.pending = true;
        API.takeInWork(this.assignmentExecutor?.id)
          .then(() => {
            this.dialogTakeInWork = false;
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.pending = false;
          });
      },

      close() {
        const queryParams = history.state?.location;
        if (queryParams) {
          this.$router.push({ name: 'Assignments', query: queryParams, state: { location: null } });
        } else {
          this.$router.push({ name: 'Assignments' });
        }
      },
      showRefuseReason(el) {
        this.dialogRefuse = true;
        this.refuseReasons = el.mpkAssignmentExecutorRefuses;
      },
      checkIsNotNewTask(assignmentExecutor) {
        return (
          assignmentExecutor.statusId !== MPK_ASSIGNMENT_STATUS.IN_WORK ||
          assignmentExecutor.isDoneAtLeastOnce ||
          assignmentExecutor.report ||
          !!assignmentExecutor.mpkAssignmentExecutorReports?.length
        );
      },
      checkIsNotInWorkStatus(assignmentExecutor) {
        return assignmentExecutor.statusId !== MPK_ASSIGNMENT_STATUS.IN_WORK;
      },
      checkComments(assignmentExecutor) {
        return assignmentExecutor.mpkAssignmentExecutorConfirms?.length > 0 || this.item.assignmentComments?.length > 0;
      },
      showComments(executorComments) {
        const combined = [...(this.item.assignmentComments ?? []), ...(executorComments ?? [])];
        this.commentList = combined.sort((a, b) => new Date(a.created) - new Date(b.created));
        this.dialogComment = true;
      },

      fileUploaded(e) {
        this.modal.files.push(e.data);
      },
      removeFile(e) {
        var file = this.modal.files.find((x) => x.id == e.id);
        var index = this.modal.files.indexOf(file);
        if (index !== -1) {
          this.modal.files.splice(index, 1);
        }
      },
      checkInApprovalRange(assignment) {
        return (
          (assignment.statusId >= MPK_ASSIGNMENT_STATUS.APPROVAL_HEAD_FOIV &&
            assignment.statusId <= MPK_ASSIGNMENT_STATUS.COMPLETED) ||
          assignment.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_SECRETARY_EXECUTOR ||
          assignment.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_HEAD_EXECUTOR
        );
      },
      showDeadlineInput(executor) {
        return executor?.statusId === MPK_ASSIGNMENT_STATUS.APPROVAL_SECRETARY_MPK && !executor?.isExecute;
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        modal: {
          report: { required },
        },
        reason: { required },
        selectedCancelStatusId: { required },
      };
    },
  };
</script>

<style lang="scss" scoped>
  .card-mpk {
    &__body {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: flex-start;
    }

    &__card {
      padding: 30px;
      max-width: 705px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 17px rgba(55, 55, 55, 0.08);
      border-radius: 5px;

      &-row {
        display: flex;
        width: 100%;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px dashed #d7d7d7;

        p {
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;
          color: #343c44;
          margin-bottom: 0px;

          &.title-column {
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            color: #343c44;
            margin-bottom: 10px;
          }
        }
      }

      &-col {
        &1 {
          padding-right: 16px;
          max-width: 431px;
          width: 100%;
        }

        &2 {
          max-width: 201px;
          width: 100%;
        }
      }
    }

    .status-container.text-yellow {
      :deep(svg) {
        path {
          stroke: #ffc107;
        }
      }
    }

    &__executor-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    &__date-form-wrapper {
      max-width: 230px;
    }

    .report {
      &-name {
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        color: #787f8f;
      }

      &-text {
        min-height: 50px;
        margin-bottom: 16px;
      }

      &-column {
        .btn-container {
          button {
            margin-right: 8px;
            margin-bottom: 8px;

            &:last-of-type {
              margin-right: 0px;
            }
          }
        }
      }
    }

    .status {
      &-container {
        .icon {
          margin-right: 6px;
        }

        span {
          font-size: 14px;
        }
      }
    }
  }

  @media (max-width: 1125px) {
    .card-mpk .chat-btn .icon {
      display: none;
    }

    .card-mpk__body {
      flex-wrap: wrap;
    }

    .card-mpk__card {
      order: 1;
      max-width: unset;
    }

    .card-mpk__card-row {
      justify-content: space-between;
    }

    .card-mpk__card-col1,
    .card-mpk__card-col2 {
      max-width: unset;
    }
  }

  @media (max-width: 767px) {
    .card-mpk__card {
      padding: 30px 12px;
    }
  }

  @media (max-width: 710px) {
    .card-mpk__card-row {
      flex-wrap: wrap;

      .card-mpk__card-col1 {
        margin-bottom: 8px;
      }

      .card-mpk__card-col2,
      .card-mpk__card-col1 {
        padding-right: 0px;
      }

      &.report {
        .card-mpk__card-col2 {
          order: 0;
          margin-bottom: 8px;
        }

        .card-mpk__card-col1 {
          order: 1;
        }

        .btn-container {
          flex-wrap: wrap;
        }
      }
    }
  }

  @media (max-width: 320px) {
    .card-mpk__card-row {
      &.report {
        .btn-container {
          flex-wrap: wrap;

          button {
            width: 100%;
            margin-right: 0px;

            &:nth-of-type(1) {
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }

  .deadline {
    color: #787f8f;
    display: block;
  }

  .required .form-label:after {
    content: '*';
    color: red;
    margin-left: 2px;
  }
</style>
